import { Flex, Table } from '@mantine/core'

import type { TableItemProps } from '@/modules/employerUsers/pages/components/TableItem/TableItem.types'

import { Button } from '@/components/Button/Button'
import { MoreDropdown } from '@/components/MoreDropdown/MoreDropdown'
import { Text } from '@/components/Text/Text'

import { role as Roles } from '@/__generated__/requests'

import { sanitizeEnum } from '@/helpers/sanitizeEnum.helper'

import classes from './TableItem.module.css'

export function TableItem({
  empty = false,
  item,
  openDeleteModal,
  openUpdateModal,
}: TableItemProps) {
  if (!item || empty) {
    return (
      <Table.Tr className={classes.emptyTableItem}>
        <Table.Td miw="100%">
          <Text variant="body_2_semibold_black">No users</Text>
        </Table.Td>
      </Table.Tr>
    )
  }

  const newRole = item?.roles?.includes(Roles.EMPLOYEE)
    ? Roles.EMPLOYER
    : Roles.EMPLOYEE

  let dropdownItems

  if (openDeleteModal && openUpdateModal && !empty) {
    dropdownItems = [
      {
        label: `Change role to ${newRole?.toLowerCase()}`,
        onClick: openUpdateModal,
        param: item.id.toString(),
      },
      {
        label: 'Delete',
        onClick: openDeleteModal,
        param: item.id.toString(),
      },
    ]
  }

  const handleContactUser = () => {
    window.location.href = `mailto:${item.email}`
  }

  return (
    <Table.Tr className={classes.tableItem}>
      <Table.Td miw={250}>
        <Text variant="body_2_medium_black">
          {`${item.firstName} ${item.lastName}`}
        </Text>
      </Table.Td>
      <Table.Td miw={220}>
        <Text variant="body_2_black">{item.email}</Text>
      </Table.Td>
      <Table.Td miw={160}>
        <Text variant="body_2_black">
          {sanitizeEnum(
            item.roles?.includes(Roles.EMPLOYEE)
              ? Roles.EMPLOYEE
              : Roles.EMPLOYER,
          )}
        </Text>
      </Table.Td>
      <Table.Td miw={160}>
        <Flex align="center" gap={16}>
          <Button h={34} miw={0} onClick={handleContactUser} variant="primary">
            Contact
          </Button>
          {dropdownItems && <MoreDropdown items={dropdownItems} />}
        </Flex>
      </Table.Td>
    </Table.Tr>
  )
}
